const diretoria = {
  diretores: [
    {
      nome: 'Carlos Ambrósio',
      cargo: 'Presidente',
      descricao: 'Claritas Administração de Recursos',
      imagem: 'diretoria1',
    },
    {
      nome: 'Carlos André',
      cargo: 'Vice-presidente',
      descricao: 'BB DTVM',
      imagem: 'diretoria2',
    },
    {
      nome: 'Carlos Constantini',
      cargo: 'Vice-presidente',
      descricao: 'Itaú Unibanco',
      imagem: 'diretoria3',
    },
    {
      nome: 'Gilberto Duarte ',
      cargo: 'Vice-presidente',
      descricao: 'Santander ',
      imagem: 'Gilberto-Duarte',
    },
    {
      nome: 'José Eduardo Laloni',
      cargo: 'Vice-presidente',
      descricao: 'ABC Brasil',
      imagem: 'diretoria4',
    },
    {
      nome: 'Luiz Sorge',
      cargo: 'Vice-presidente',
      descricao: 'BNP Paribas Brasil',
      imagem: 'diretoria5',
    },
    {
      nome: 'Pedro Lorenzini',
      cargo: 'Vice-presidente',
      descricao: 'Citibank',
      imagem: 'diretoria7',
    },
    {
      nome: 'Renato Ejnisman',
      cargo: 'Vice-presidente',
      descricao: 'Bradesco',
      imagem: 'diretoria8',
    },
    {
      nome: 'Sergio Cutolo',
      cargo: 'Vice-presidente',
      descricao: 'BTG Pactual',
      imagem: 'diretoria9',
    },
    {
      nome: 'Adriano Koelle',
      cargo: 'Diretor',
      descricao: 'BNY Mellon',
      imagem: 'diretoria10',
    },
    {
      nome: 'Carlos Takahashi',
      cargo: 'Diretor',
      descricao: 'BlackRock',
      imagem: 'Carlos-Massaru',
    },
    {
      nome: 'Eduardo Azevedo',
      cargo: 'Diretor',
      descricao: 'Tullett Prebon',
      imagem: 'Eduardo-Azevedo',
    },
    {
      nome: 'Fernando Rabello',
      cargo: 'Diretor',
      descricao: 'Safra',
      imagem: 'diretoria12',
    },
    {
      nome: 'Gabriel Cardozo',
      cargo: 'Diretor',
      descricao: 'Caixa',
      imagem: 'GABRIEL-CARDOZO',
    },
    {
      nome: 'Gabriel Leal',
      cargo: 'Diretor',
      descricao: 'XP Investimentos',
      imagem: 'Gabriel-Leal',
    },
    {
      nome: 'Jan Karsten',
      cargo: 'Diretor',
      descricao: 'Julius Baer',
      imagem: 'diretoria13',
    },
    {
      nome: 'Luciane Ribeiro',
      cargo: 'Diretora',
      descricao: 'Votorantim',
      imagem: 'Luciane-Ribeiro',
    },
    {
      nome: 'Luiz Chrysostomo',
      cargo: 'Diretor',
      descricao: 'Neo Gestão de Recursos',
      imagem: 'diretoria15',
    },
    {
      nome: 'Luiz Fernando Figueiredo',
      cargo: 'Diretor',
      descricao: 'Mauá Capital',
      imagem: 'diretoria16',
    },
    {
      nome: 'Lywal Salles Filho',
      cargo: 'Diretor',
      descricao: 'Vinci Partners',
      imagem: 'diretoria17',
    },
    {
      nome: 'Pedro Juliano',
      cargo: 'Diretor',
      descricao: 'JP Morgan',
      imagem: 'diretoria18',
    },
    {
      nome: 'Pedro Rudge',
      cargo: 'Diretor',
      descricao: 'Leblon Equities',
      imagem: 'diretoria19',
    },
    {
      nome: 'Teodoro Lima',
      cargo: 'Diretor',
      descricao: 'Credit Suisse',
      imagem: 'diretoria21',
    },
  ],
};

export { diretoria };
